<template>
  <div>
    <div class="entete pdb-20px border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('ajoutSponsoringDcf.title')}}</h1>
              <breadcrumb :breadcrumb="$route.params.breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="annuler()"
               class="button">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="pdt-20px">
      <div class="columns level">
        <div class="column">
          <form @submit.prevent="recherche()" class="column is-5 pdl-0 pdr-0">
            <b-input
              v-model="briefStocke.auto"
              :placeholder="$t('general.autocomplete.search')"
              type="search" icon="magnify">
            </b-input>
          </form>
        </div>
        <div class="column">
          <div class="column is-pulled-right is-paddingless">
            <button class="button" @click='showPanier = !showPanier'>
              <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{ $t('general.button.panier') }}
                </span>
            </button>
            <div class="info-circle-right background-danger is-pulled-right"
                 v-if="panier.length > 0">
              <span class="inside-circle">{{ panier.length > 9 ? '9+' : panier.length }}</span>
            </div>
          </div>
          <div class="column is-pulled-right pdt-0">
            <button class="button" @click='showBrief = !showBrief'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{ $t('general.button.brief') }}
              </span>
            </button>
            <div class="info-circle-right background-primary is-pulled-right"
                 :class="{ 'is-invisible': nombreFiltre === 0 }">
              <span class="inside-circle">{{ nombreFiltre }}</span>
            </div>
          </div>
        </div>
      </div>
      <v-server-table class="mgt-10px"
                      url="" v-if="startArrayRendering"
                      :columns="columns"
                      :options="options"
                      @loaded="finLoading"
                      @loading="debutLoading"
                      @error="finLoading"
                      ref="tableListeProduits">
        <template slot='afterTable'>
          <table-items-in-view :perPage="constantes.RESULTS_PER_PAGE_PLANNING"
                               @input="$refs.tableListeProduits.setLimit($event)"/>
        </template>
        <div slot="addPanier" slot-scope="props" class="has-text-centered">
          <button
            class="ripple button" :class="getColorAddPanier(props.row.id)"
            @click="openLiaisonSearch(props.row)">
            <b-icon icon="cart"></b-icon>
          </button>
        </div>
        <div slot="typeProduit" slot-scope="props">
          {{ getTypeProduitById(props.row.produitSponsoring.typeProduitId) }}
        </div>
        <div slot="dateDebut" slot-scope="props">
          {{ props.row.produitSponsoring.dateDebut | formatDate }}
        </div>
        <div slot="dateFin" slot-scope="props">
          {{ props.row.produitSponsoring.dateFin | formatDate }}
        </div>
        <div slot="societe" slot-scope="props">
          <div>{{ getLibelleSociete(props.row.supportCommercial.societeId) }}</div>
        </div>
      </v-server-table>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showPanier || showBrief ">
        <brief-produit-sponsoring v-if="showBrief"
               @toggleBrief="showBrief = !showBrief"
               @appliquerBrief="recherche()"/>
        <panier-ajout-sponsoring
          :isDevisCommandePartiellement="isDevisCommandePartiellement"
          @togglePanier="showPanier = !showPanier"
          @ajouterLigneToCommande="$router.go(-1)"
          v-if="showPanier"/>
      </div>
    </transition>
    <b-modal v-model="popUpSelectionLiaisonTarif" has-modal-card class="modal">
      <display-liaison-tarif-of-produit :liaisonsTarif="liaisonsTarif"
                                        :produit="produit"
                                        @addIndcf="ajouterAuDevisCommande"/>
    </b-modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import tableItemsInView from '@/components/general/TableItemsInView';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_COMMANDE_PARTIELLEMENT } from '@/configuration/devisConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE_PLANNING,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '@/store/modules/commande-mutation-type';
import * as typesProduitSponsoring from '@/store/modules/bodac/catalogue/produitSponsoring-mutation-type';
import getLignesCommandesWithType
  from '@/services/devisCommandes/ligneCommande/getLignesCommandesWithType';
import { CATEGORIE_SPONSORING } from '@/configuration/catalogue/produitConf';
import messageErreur from '@/services/general/messageErreur';
import { ROUTE_ALLOWED_WITHOUT_CLEAN_STORE } from '@/configuration/planning/planningConf';
import briefProduitSponsoring from '@/components/devisCommandes/brief/briefProduitSponsoring';
import panierAjoutSponsoring
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/panier/panierAjoutSponsoring';
import { get } from '@/api/produit/produitSponsoring';
import displayLiaisonTarifOfProduit
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/displayLiaisonTarifOfProduit';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Commande = createNamespacedHelpers('commande');
const ProduitSponsoring = createNamespacedHelpers('produitSponsoring');

export default {
  name: 'c_ajoutProduitSponsoring',
  data() {
    return {
      showBrief: false,
      showPanier: false,
      startArrayRendering: false,
      popUpSelectionLiaisonTarif: false,
      liaisonsTarif: [],
      produit: {},
      constantes: {
        RESULTS_PER_PAGE_PLANNING,
      },
    };
  },
  components: {
    breadcrumb,
    briefProduitSponsoring,
    tableItemsInView,
    panierAjoutSponsoring,
    displayLiaisonTarifOfProduit,
  },
  computed: {
    ...ProduitSponsoring.mapGetters({
      produits: 'produits',
      totalProduits: 'totalProduits',
      briefStocke: 'brief',
      panier: 'panier',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    isDevisCommandePartiellement() {
      return this.commandeCourante.etat === ETAT_COMMANDE_PARTIELLEMENT;
    },
    nombreFiltre() {
      const nbCritere = calculNombreCritere(this.briefStocke, ['agencesId']);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    typesProduit() {
      return this.parametre(PARAMETRES_KEYS.typeProduit);
    },
    columns() {
      const columns = ['addPanier', 'reference', 'libelle', 'typeProduit', 'dateDebut', 'dateFin'];
      if (this.societesInformations.length > 1 && !this.filtrerProduitParSociete
        && !this.filtrerProduitParAgence) {
        columns.push('societe');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          addPanier: '',
          reference: this.$i18n.t('ajoutSponsoringDcf.table.code'),
          libelle: this.$i18n.t('ajoutSponsoringDcf.table.libelle'),
          dateDebut: this.$i18n.t('ajoutSponsoringDcf.table.dateDebut'),
          dateFin: this.$i18n.t('ajoutSponsoringDcf.table.dateFin'),
          typeProduit: this.$i18n.t('ajoutSponsoringDcf.table.typeProduit'),
          societe: this.$i18n.t('ajoutSponsoringDcf.table.societe'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE_PLANNING,
        texts: TEXTS,
        sortable: ['reference', 'libelle'],
        columnsClasses: {
          ...this.columns.reduce((acc, val) => {
            acc[val] = 'sticky';
            return acc;
          }, {}),
          addPanier: 'colonneSelected-35 is-paddingless sticky',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.briefStocke.agencesId.length === 0) {
            this.briefStocke.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.briefStocke);
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.actionsLoadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
  },
  methods: {
    ...ProduitSponsoring.mapActions({
      actionsLoadProduits: 'loadProduits',
      actionsAddLigneInPanier: 'addLigneInPanier',
    }),
    ...Commande.mapMutations({
      removeCommande: types.REMOVE_COMMANDE,
      setCommande: types.SET_COMMANDE,
    }),
    ...ProduitSponsoring.mapMutations({
      clearPanier: typesProduitSponsoring.CLEAR_PANIER,
      clearBrief: typesProduitSponsoring.CLEAR_BRIEF,
      setPanier: typesProduitSponsoring.SET_PANIER,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    async openLiaisonSearch(produit) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.produit = produit;
        const produitResult = (await get(produit.id)).data.result;
        const liaisons = produitResult.liaisonsTarif;
        liaisons.forEach((el) => {
          el.selected = false;
        });
        const prestations = produitResult.produitSponsoring.prestations;
        prestations.forEach((el) => {
          el.selected = false;
        });
        this.liaisonsTarif = [...liaisons, ...prestations];
        this.popUpSelectionLiaisonTarif = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getTypeProduitById(id) {
      if (!id) return '';
      const typeProduitFind = this.typesProduit.find((el) => el.id === id);
      if (typeProduitFind) return typeProduitFind.libelle;
      return '';
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    annuler() {
      this.clearPanier();
      this.clearBrief();
      const ligneRegroupementSponsoring = getLignesCommandesWithType(
        this.commandeCourante.lignesCommande, CATEGORIE_SPONSORING,
      );
      this.setPanier(ligneRegroupementSponsoring);
      this.$router.go(-1);
    },
    getColorAddPanier(idProduit) {
      if (!this.panier) return 'is-primary';
      const isAlreadyAdd = this.panier.some((ligne) => {
        return idProduit === ligne.produitId;
      });
      if (isAlreadyAdd) return 'is-success';
      return 'is-primary';
    },
    recherche() {
      this.$refs.tableListeProduits.refresh();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async ajouterAuDevisCommande(data) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.produit = {};
        this.liaisonsTarif = [];
        await data.liaisonsId.forEach(async liaisonId => {
          const newline = {
            produitId: data.produitId,
            liaisonsId: [liaisonId],
          };
          await this.actionsAddLigneInPanier(newline);
        });
        this.popUpSelectionLiaisonTarif = false;

        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!ROUTE_ALLOWED_WITHOUT_CLEAN_STORE.includes(to.name)) {
      this.removeCommande();
      this.clearPanier();
      this.clearBrief();
    }
    next();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSocietes({});
      if (!this.$route.params.breadcrumb) {
        this.removeCommande();
        this.$router.go(-1);
      }
      await this.loadParametres([PARAMETRES_KEYS.typeProduit]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
      ]);
      if (this.commandeCourante) {
        const lignesRegroupementSponsoring = getLignesCommandesWithType(
          this.commandeCourante.lignesCommande, CATEGORIE_SPONSORING,
        );
        lignesRegroupementSponsoring.forEach((ligne) => { ligne.isFromDCF = true; });
        this.setPanier(lignesRegroupementSponsoring);
      }
      if (this.filtrerProduitParAgence) {
        this.briefStocke.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.startArrayRendering = true;
      this.setInformationPage(this.$t('pageGescom.planning.sponsoring'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
